export default __webpack_public_path__ + "static/joshua2-517fff431b66b3259b834757a16ffd73.png";